import { legacyApiAuth, defaultApiBasicX } from '../../apis'
import { IResponseService } from '../charts'
import type { IResponseGetLists } from '../../interfaces'

export const postPublishNewList = async ({
  propertiesIds,
  origin,
  name
}: {
  propertiesIds: string
  name: string
  origin: string
}) => {
  await legacyApiAuth.post('/v2.0.2/public_lists', {
    property_ids: propertiesIds,
    origin,
    name
  })
  try {
    return {
      isSuccess: true
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export interface IList {
  createdAt: string
  id: string
  listCode: string
  listPropertiesCount: number
  name: string
  propertyExists: boolean
  updatedAt: string
  viewCount: string
}

export interface IListResponse {
  lists: IList[]
  pagination: {
    currentPage: number
    pages: number
    totalItems: number
  }
}
interface IGetListParams {
  page?: number
  pages?: number
  perPage?: number
  propertyExists?: string
  search?: string
  validateProperty?: string
}

export const getLists = async (
  { perPage = 25, page = 1, search, validateProperty }: IGetListParams = {},
  signal?: AbortSignal
): Promise<IResponseService<IListResponse>> => {
  try {
    const response = await defaultApiBasicX.get<
      IResponseService<IListResponse>
    >(`/properties-lists/lists/property_exists`, {
      params: {
        perPage,
        page,
        search,
        validateProperty
      },
      signal
    })

    return {
      isSuccess: true,
      data: response?.data
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export const getListsLegacy = async ({
  page,
  limit = 50,
  validateItems,
  search
}: {
  page: number
  limit?: number
  validateItems: string
  search?: string
}): Promise<IResponseService<IResponseGetLists>> => {
  try {
    const res = await legacyApiAuth.get<IResponseGetLists>(
      '/v2.0.2/public_lists',
      {
        params: {
          p: page,
          l: limit,
          validate_item: validateItems,
          search
        }
      }
    )

    return {
      isSuccess: true,
      data: res
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export const addPropertyToList = async ({
  propertyId,
  listId
}: {
  listId: string
  propertyId: string
}) => {
  await defaultApiBasicX.post(
    `/properties-lists/lists/${listId}/add-properties`,
    {
      propertyIds: [propertyId]
    }
  )
  try {
    return {
      isSuccess: true
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export const removePropertyFromList = async ({
  propertyId,
  listId
}: {
  listId: string
  propertyId: string
}) => {
  await defaultApiBasicX.patch(`/properties-lists/lists/${listId}/property`, {
    propertyId
  })
  try {
    return {
      isSuccess: true
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export const postPublishPropertiesInList = async ({
  propertyIds,
  publicListId,
  origin
}: {
  propertyIds: string[]
  publicListId: string
  origin: string
}) => {
  await legacyApiAuth.post(`/v2.0.2/public_lists/${publicListId}/items`, {
    property_ids: propertyIds,
    origin
  })
  try {
    return {
      isSuccess: true
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export const deletePropertiesInList = async ({
  publicListId,
  propertyIds
}: {
  publicListId: string
  propertyIds: string[]
}) => {
  await legacyApiAuth.delete(`/v2.0.2/public_lists/${publicListId}/items`, {
    data: {
      property_ids: propertyIds
    }
  })
  try {
    return {
      isSuccess: true
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

interface IPropertySeenInteractionProps {
  link: string
  propertyLegacyIds: string[]
  userId: string
  type: string
}

interface IPropertySeenInteraction {
  propertyLegacyIds: string[]
  interactionType: string
  data?: IPropertySeenInteractionProps
  metadata: {
    link: string
  }
  source: string
  userId: string
}

export const propertyInteraction = async ({
  propertyLegacyIds,
  link,
  userId,
  type
}: IPropertySeenInteractionProps): Promise<
  IResponseService<IPropertySeenInteractionProps>
> => {
  try {
    const response = await defaultApiBasicX.post<
      IPropertySeenInteraction,
      IPropertySeenInteraction
    >(`lead-management/interaction/property`, {
      propertyLegacyIds,
      interactionType: type,
      metadata: {
        link
      },
      source: 'WIGGOT_PUBLIC_DATA_SHEET',
      userId: userId?.toString() || ''
    })

    return {
      isSuccess: true,
      data: response?.data
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}
